import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface HealthScoreState {
  isLoading: boolean
  error: string | undefined
  scoreData: number
  httpStatus: number | undefined
}

export const initialState: HealthScoreState = {
  isLoading: false,
  error: undefined,
  scoreData: 0,
  httpStatus: 0
}

const healthScoreSlice = createSlice({
  name: 'HealthScoreState',
  initialState,
  reducers: {
    healthScoreLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        scoreData: 0,
        httpStatus: 0
      }
    },
    healthScoreUpdateAction: (state, action: PayloadAction<{ data: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        scoreData: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    healthScoreErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        scoreData: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  healthScoreLoadingAction,
  healthScoreUpdateAction,
  healthScoreErrorAction
} = healthScoreSlice.actions

export default healthScoreSlice.reducer
